export default "__VITE_ASSET__1d9d2c03__"